var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person-search"},[(!_vm.searched)?_c('PersonSearchForm',{on:{"personSearch":_vm.search}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }